import { Theme } from '@mui/material';
import { OpCo, OptimizelyFlags } from '../types/type';
import { afiChameleonFinalTheme } from './afiChameleonFinalTheme';
import { geicoChameleonFinalTheme } from './geicoChameleonFinalTheme';
import { hsChameleonFinalTheme } from './hsChameleonFinalTheme';
import { lemonadeChameleonFinalTheme } from './lemonadeChameleonFinalTheme';
import { msaChameleonFinalTheme } from './msaChameleonFinalTheme';
import { progressiveChameleonFinalTheme } from './progressiveChameleonFinalTheme';

const themeMap: { [key: string]: Theme } = {
  msaChameleonFinalTheme,
  hsChameleonFinalTheme,
  lemonadeChameleonFinalTheme,
  afiChameleonFinalTheme,
  geicoChameleonFinalTheme,
  progressiveChameleonFinalTheme,
};

export function loadThemeByOpCoId(opcoId: string, featureFlags: OptimizelyFlags): Theme {
  let themeName = 'afiChameleonFinalTheme'; // Default theme fallback

  switch (opcoId) {
    case OpCo.AMFAM:
      themeName = 'afiChameleonFinalTheme';
      break;
    case OpCo.MSA:
      themeName = 'msaChameleonFinalTheme';
      break;
    case OpCo.HOMESITE:
      themeName = 'hsChameleonFinalTheme';
      break;
    case OpCo.LEMONADE:
      themeName = 'lemonadeChameleonFinalTheme';
      break;
    case OpCo.GEICO:
      themeName = 'geicoChameleonFinalTheme';
      break;
    case OpCo.PROGRESSIVE:
      themeName = 'progressiveChameleonFinalTheme';
      break;

    default:
      console.warn(`Unknown opcoId "${opcoId}", falling back to afiChameleonFinalTheme`);
      themeName = 'afiChameleonFinalTheme';
      break;
  }
  return themeMap[themeName];
}
